import {IonRouterLink} from "@ionic/react";
import React from "react";
import dayjs from "dayjs";

import {Breadcrumbs} from "../../../components";
import ChatIcon from "../../../components/ChatIcon";

import {useQuery} from "@apollo/client";
import {GET_ALL_MY_ORDERS} from "../../../graphql/queries/myorder.query";

import "./servizi.style.css";
import Loading from "../../../components/Loading";
import toast from "react-hot-toast";
import {JWT_TOKEN, API_URL} from "../../../constants/appConfig";
import {
  getLocalStorage,
  getLocalSession,
} from "../../../lib/utils/storage.utils";
import Pagination from "../../../components/pagination/pagination";

const PersonalServizi = () => {
  const [orderList, setOrderList] = React.useState<any[]>([]);
  const [activeRows, setActiveRows] = React.useState<number[]>([]);
  const [offset, setOffset] = React.useState(0);
  const limit = 10;

  //
  const {data, loading} = useQuery(GET_ALL_MY_ORDERS, {
    variables: {
      offset,
      limit,
    },
    fetchPolicy: "cache-and-network",
    onCompleted(data) {
      const actualData = data?.getAllMyOrders?.data ?? [];

      const sortedData = [...actualData].sort((a: any, b: any) => {
        const aIsSuspended = a.orderedService?.filter(
          (itm: any) => itm.suspendedAt
        )?.length;
        const bIsSuspended = b.orderedService?.filter(
          (itm: any) => itm.suspendedAt
        )?.length;

        return bIsSuspended - aIsSuspended;
      });

      setOrderList(sortedData);

      // const newArr = actualData.map((_item: any, index: number) => index);
      // setActiveRows(newArr);
    },
  });

  //
  const breadcrumbEntries = [
    {title: "Area personale", link: "/personale"},
    {title: "Le mie pratiche"},
  ];

  //
  const getStatusText = (status: string) => {
    switch (status) {
      case "archived":
        return "Archiviato";
      case "received":
        return "Pervenuto";
      case "completed":
        return "Completato";
      case "progress":
        return "In corso";

      case "richiesta":
        return "Richiesta";

      case "assegnata":
        return "Assegnata";

      case "rifiutata":
        return "Rifiutata";

      case "in-attesa-pagamento":
        return "In Attesa Pagamento";

      case "in-attesa-evasione":
        return "In Attesa Evasione";

      case "sospesa":
        return "Sospesa";

      case "practica-evasa":
        return "Pratica evasa";

      case "pratica-annullata":
        return "Pratica Annullata";

      default:
        return status;
    }
  };

  //
  const getOrderType = (order: any) => {
    const allOrderTypes =
      order?.orderedService?.map((os: any) => os?.service?.rootType) ?? [];

    return allOrderTypes.length > 1 ? "Servizi multiple" : allOrderTypes[0];
  };

  //
  const getIntestatarioName = (order: any) => {
    const {secondAccHolder, accHolder, accountHolder} = order;
    let intestatario;
    if (secondAccHolder) {
      intestatario = secondAccHolder;
    }
    if (accHolder) {
      intestatario = accHolder;
    }
    if (accountHolder && !intestatario) {
      return accountHolder ?? "N/A";
    }
    if (typeof intestatario === "string") {
      return intestatario;
    }
    const label =
      intestatario?.name ??
      intestatario?.firstName + " " + intestatario?.lastName;
    return label;
  };

  //
  const getServiceId = (order: any) => {
    return order?.orderedService?.map((os: any) => os?.service?.id)?.[0] ?? 0;
  };

  //
  const getRedirectUrl = (order: any, serviceType: string) => {
    const servId = getServiceId(order);

    return `/personale/add-to-cart?serviceId=${servId}&serviceType=${serviceType}&masterId=${order.id}`;
  };

  //
  const toggleActiveRow = (index: number) => {
    if (activeRows.includes(index)) {
      const others = activeRows.filter((itm) => itm !== index);
      setActiveRows(others);
    } else {
      const others = [...activeRows, index];
      setActiveRows(others);
    }
  };

  //
  const formatPraticheNumber = (number: number | string, year: Date) => {
    const yearOnly = dayjs(year).get("y");
    return `${number.toString().padStart(4, "0")}/${yearOnly}`;
  };

  //
  const openInvoiceInNewTab = async (prautoPraticheId: number) => {
    console.log(prautoPraticheId, "what am i sending here");
    if (!prautoPraticheId) {
      toast.error("ID pratica non valido.");
      return;
    }

    try {
      const token = getLocalStorage(JWT_TOKEN) || getLocalSession(JWT_TOKEN);
      if (!token) {
        toast.error("Token non trovato. Effettua il login.");
        return;
      }

      const response = await fetch(
        `${API_URL}/api/user/invoice-pdf/${prautoPraticheId}`,
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        }
      );

      if (!response.ok) {
        throw new Error("Errore nel recupero della fattura.");
      }

      const responseBlob = await response.blob();
      const blob = new Blob([responseBlob], {type: "application/pdf"});
      const blobUrl = URL.createObjectURL(blob);
      window.open(blobUrl, "_blank");
    } catch (error: any) {
      toast.error(error?.message || "La fattura non viene generata o trovata.");
    }
  };

  if (loading) return <Loading />;

  //
  return (
    <div className="app-container">
      <Breadcrumbs items={breadcrumbEntries} />

      <div className="servizi-container">
        <table className="responsive-table">
          <thead>
            <tr>
              <th>Numero pratica</th>
              <th>Dylog ID</th>
              <th>Data</th>
              <th>Stato</th>
              <th>Intestatario</th>
              <th>Note Pubbliche</th>
              <th></th>
            </tr>
          </thead>

          <tbody>
            {orderList &&
              orderList.length > 0 &&
              orderList.map((order, index) => (
                <React.Fragment key={index}>
                  <tr>
                    <td
                      data-label="Numero pratica"
                      style={{textAlign: "center"}}
                    >
                      {formatPraticheNumber(order.id, order.createdAt)}
                    </td>
                    <td data-label="Dylog Id" style={{textAlign: "center"}}>
                      {order.dylogSyncCompleted ? (
                        <>
                          {order.prautoPraticheCaseNumber} /{" "}
                          {order.prautoPraticheYear}
                        </>
                      ) : (
                        "-"
                      )}
                    </td>
                    <td data-label="Data">
                      {dayjs(order.createdAt).format("DD/MM/YYYY")}
                    </td>
                    <td data-label="Stato"> {getStatusText(order.status)} </td>

                    <td data-aria-label="Intestatario">
                      {getIntestatarioName(order)}
                    </td>

                    <td data-label="Note Pubbliche">
                      {order.secondaryNote ?? "-"}
                    </td>

                    <td className="buttons-items">
                      <div className="servizi-flex-buttons">
                        <div className="servizi-chat-icon">
                          <ChatIcon
                            roomId={order.roomId}
                            id={order.id}
                            category="order"
                            orderNumber={""}
                          />
                        </div>
                        <div>
                          <IonRouterLink
                            href={`/personale/servizi/${order.id}`}
                          >
                            <div className="servizi-button">
                              <span>Vedi dettagli</span>
                              {order.masterId && (
                                <span style={{marginLeft: "5px"}}>*</span>
                              )}
                            </div>
                          </IonRouterLink>
                        </div>

                        {!order.masterId && (
                          <>
                            {["pec", "smartCard"].includes(
                              getOrderType(order)
                            ) && (
                              <div>
                                <IonRouterLink
                                  href={getRedirectUrl(order, "renewal")}
                                >
                                  <div className="servizi-button">
                                    Rinnovo{" "}
                                    {getOrderType(order) === "smartCard"
                                      ? "smartacard"
                                      : getOrderType(order) === "pec"
                                      ? "pec"
                                      : "annualità"}
                                  </div>
                                </IonRouterLink>
                              </div>
                            )}

                            {/* 
                            {getOrderType(order) === 'lease' && (
                              <>
                                <div>
                                  <IonRouterLink
                                    href={getRedirectUrl(order, 'extension')}
                                  >
                                    <div className='servizi-button'>
                                      Proroga
                                    </div>
                                  </IonRouterLink>
                                </div>

                                <div>
                                  <IonRouterLink
                                    href={getRedirectUrl(order, 'transfer')}
                                  >
                                    <div className='servizi-button'>
                                      Cessione
                                    </div>
                                  </IonRouterLink>
                                </div>

                                <div>
                                  <IonRouterLink
                                    href={getRedirectUrl(order, 'terminate')}
                                  >
                                    <div className='servizi-button'>
                                      Risoluzione
                                    </div>
                                  </IonRouterLink>
                                </div>
                              </>
                            )} */}

                            {order.dylogSyncCompleted > 0 && (
                              <div
                                className="servizi-button"
                                style={{
                                  cursor: "pointer",
                                }}
                                onClick={() => {
                                  openInvoiceInNewTab(order.prautoPraticheId);
                                }}
                              >
                                Scarica la fattura
                              </div>
                            )}
                          </>
                        )}
                      </div>

                      <div className="expand-row">
                        <div
                          className="expand-row-item"
                          onClick={() => toggleActiveRow(index)}
                        >
                          {activeRows.includes(index) && <ExpandIcon />}
                          {!activeRows.includes(index) && <ExpandIconN />}
                        </div>
                      </div>
                    </td>
                  </tr>

                  {activeRows.includes(index) && (
                    <tr>
                      <td colSpan={24}>
                        <OrderedServices order={order} />
                      </td>
                    </tr>
                  )}
                </React.Fragment>
              ))}
          </tbody>
        </table>
        {orderList.length < 1 && (
          <div className="no-items">Nessuna pratica!</div>
        )}
      </div>
      <div
        style={{
          display: "flex",
          justifyContent: "end",
          alignItems: "center",
          marginTop: "40px",
        }}
      >
        <Pagination
          total={data?.getAllMyOrders?.count ?? 0}
          limit={limit}
          offset={offset}
          onChange={setOffset}
        />
      </div>
    </div>
  );
};

interface IOrderedServicesProps {
  order?: any;
}

const OrderedServices = ({order}: IOrderedServicesProps) => {
  const getAdminDetails = (os: any) => {
    return os?.admin?.firstName
      ? os?.admin?.firstName + " " + os?.admin?.lastName
      : "Not assigned!";
  };

  return (
    <>
      <p>
        <strong>Note pratica</strong>
        <div>{order?.description ?? "-"}</div>
      </p>

      <table className="nested-table">
        <thead>
          <tr>
            <th>Servizio</th>
            <th>Assegnatario</th>
            <th>Stato</th>
            <th>Note Sospeso</th>
          </tr>
        </thead>

        <tbody>
          {order?.orderedService?.map((os: any, index: number) => (
            <tr key={index}>
              <td data-label="Servizio">{os?.service?.name}</td>
              <td data-label="Assegnatario">{getAdminDetails(os)}</td>
              <td data-label="Stato">{os?.status}</td>
              <td data-label="Note Sospeso">{os?.suspendedNote ?? "-"}</td>
            </tr>
          ))}
        </tbody>
      </table>
    </>
  );
};

const ExpandIconN = () => {
  return (
    <svg
      width="16"
      height="10"
      viewBox="0 0 16 10"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M1 1.53409L8 8.69318L15 1.53409"
        stroke="white"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};

const ExpandIcon = () => {
  return (
    <svg
      width="16"
      height="10"
      viewBox="0 0 16 10"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M15 8.69318L8 1.53409L1 8.69318"
        stroke="white"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};

export default PersonalServizi;
